import React from "react";
import "./Review.css";

const Review = (props) => {
  const { Name, Comment, Ratings, img } = props.review;
  return (
    <div>
      <div className="reviews">
        <img src={img} alt="" />
        <h2>Name:{Name}</h2>
        <p>Reviews: {Comment}</p>
        <p>Ratings: {Ratings} Stars</p>
      </div>
    </div>
  );
};

export default Review;
